
/*
 * Our Icons
 *
 * An Icon consists of the following:
 *  - rectangle
 *  - label
 *  - image
 *
 *  or
 *
 *  - rectangle
 *  - middle aligned label
 */

function IconClass( w, h )
{
    this.labelStr = "";
    this.onclick = null;
    this.w = w;
    this.h = h;
    this.labelAlign = "middle";
    this.fontSize = "14";
}

IconClass.prototype.DrawRect = function( myCanvas )
{
    var rect = myCanvas.rect(0, 0, this.w, this.h);
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = this.onclick;
    return rect;
}

IconClass.prototype.DrawLabel = function( rect, myCanvas )
{
    var xl = this.w/2;
    var yl = this.h/2;
    var label = myCanvas.text( xl, yl, this.labelStr);
    label.attr("font-size", this.fontSize);
    label.attr("fill", "#003E70");
    setSelectableTrigger(label, rect, icon_rect_attr, selected_attr );
    label.node.onclick = this.onclick;
    return label;
}

IconClass.prototype.Draw = function( myCanvas )
{
    var rect = this.DrawRect( myCanvas );
    var label = this.DrawLabel( rect, myCanvas );
    //this.DrawIcon( myCanvas );
    var st = ribbonCanvas.set();
    st.push(rect, label );
    return st;
}

function drawShapeIcon( category, label, callback, myCanvas )
{
    if( !myCanvas ) return null;
    //wood shapes
    if( currentMaterial["Type"] === "Visually Graded Lumber")
    {
        return drawWoodShapeIcon( label, callback, myCanvas );
    }
    
    //steel shapes (including parametric)
    if( category == "W" || category == "M" || category == "S" || category == "HP" ){
        return drawIShapeIcon( label, callback, myCanvas );
    }
    else if( category == "WT" || category == "MT" || category == "ST"){
        return drawTShapeIcon( label, callback, myCanvas );
    }
    else if( category == "C" || category == "MC" ){
        return drawCShapeIcon( label, callback, myCanvas );
    }
    else if( category == "L" ){
        return drawLShapeIcon( label, callback, myCanvas );
    }
    else if( category.match(/HSS/) ){
        return drawHSSShapeIcon( label, callback, myCanvas );
    }
    else if( category == "Parametric"){
        return drawLabelIcon( label, callback, myCanvas );
    }
    
    if( !category ){
        alert( "shape category does not exist!!!");
        //return drawLabelIcon( label, callback, myCanvas );
    }
    return null;
}

function drawMiniIcon( w, h, label, callback, myCanvas )
{
    //background rect
    var rect = myCanvas.rect(0, 0, w, h );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWShapes(); }
    var l = myCanvas.text(w/2, h/2, label);
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;
    var st = myCanvas.set();
    st.push(rect, l );
    return st;
}

function drawWoodShapeIcon( label, callback, myCanvas )
{
    //background rect
    if( !label ) label = "Wood Shape";
    var rect = myCanvas.rect(0, 0, steelShapeIconRect[0], steelShapeIconRect[1] );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWShapes(); }
    //shape
    var rectShape = myCanvas.rect(0, 0, 10, 28 );
    rectShape.attr( wood_span_attr );
    //setSelectable(rect, icon_rect_attr, selected_attr);
    //var rectShape = drawIShape( 28, 28, 4, myCanvas );
    //wShape.attr( steel_shape_attr );
    setSelectableTrigger( rectShape, rect, icon_rect_attr, selected_attr );
    rectShape.translate( (steelShapeIconRect[0] - 10)/2, 6 );
    rectShape.node.onclick = callback;//function(){ GetWShapes(); }
    var l = myCanvas.text(iconCenter[0], iconRect[1] - 12, label);
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;//function(){ GetWShapes(); }
    var st = myCanvas.set();
    st.push(rect, rectShape, l );
    return st;
}

function drawLabelIcon( label, callback, myCanvas )
{
    //background rect
    if( !label ) label = "No Label";
    var rect = myCanvas.rect(0, 0, steelShapeIconRect[0], steelShapeIconRect[1] );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWShapes(); }
    var l = myCanvas.text(iconCenter[0], iconCenter[1], label);
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;//function(){ GetWShapes(); }
    var st = myCanvas.set();
    st.push(rect, l );
    return st;
    
}

function drawIShapeIcon( label, callback, myCanvas )
{
    //background rect
    if( !label ) label = "W Shape";
    var rect = myCanvas.rect(0, 0, steelShapeIconRect[0], steelShapeIconRect[1] );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWShapes(); }
    //shape
    var wShape = drawIShape( 28, 28, 4, myCanvas );
    wShape.attr( steel_shape_attr );
    setSelectableTrigger( wShape, rect, icon_rect_attr, selected_attr );
    wShape.translate( (steelShapeIconRect[0] - 30)/2, 8 );
    wShape.node.onclick = callback;//function(){ GetWShapes(); }
    var l = myCanvas.text(iconCenter[0], iconRect[1] - 8, label);
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;//function(){ GetWShapes(); }
    var st = myCanvas.set();
    st.push(rect, wShape, l );
    return st;
}

function drawTShapeIcon( label, callback, myCanvas )
{
    //background rect
    if( !label ) label = "WT Shape";
    var rect = myCanvas.rect(0, 0, steelShapeIconRect[0], steelShapeIconRect[1] );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWTShapes(); }
    //shape
    var wShape = drawTShape( 28, 28, 4, myCanvas );
    wShape.attr( steel_shape_attr );
    setSelectableTrigger( wShape, rect, icon_rect_attr, selected_attr );
    wShape.translate( (steelShapeIconRect[0] - 30)/2, 8 );
    wShape.node.onclick = callback;//function(){ GetWTShapes(); }
    var l = myCanvas.text(iconCenter[0], iconRect[1] - 8, label );
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;//function(){ GetWTShapes(); }
    var st = myCanvas.set();
    st.push(rect, wShape, l );
    return st;
}

function drawCShapeIcon( label, callback, myCanvas )
{
    //background rect
    if( !label ) label = "C Shape";
    var rect = myCanvas.rect(0, 0, steelShapeIconRect[0], steelShapeIconRect[1] );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWTShapes(); }
    //shape
    var wShape = drawCShape( 20, 28, 4, myCanvas );
    wShape.attr( steel_shape_attr );
    setSelectableTrigger( wShape, rect, icon_rect_attr, selected_attr );
    wShape.translate( (steelShapeIconRect[0] - 30)/2, 8 );
    wShape.node.onclick = callback;//function(){ GetWTShapes(); }
    var l = myCanvas.text(iconCenter[0], iconRect[1] - 8, label );
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;//function(){ GetWTShapes(); }
    var st = myCanvas.set();
    st.push(rect, wShape, l );
    return st;
}

function drawLShapeIcon( label, callback, myCanvas )
{
    //background rect
    if( !label ) label = "C Shape";
    var rect = myCanvas.rect(0, 0, steelShapeIconRect[0], steelShapeIconRect[1] );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWTShapes(); }
    //shape
    var shape = drawLShape( 20, 28, 4, myCanvas );
    shape.attr( steel_shape_attr );
    setSelectableTrigger( shape, rect, icon_rect_attr, selected_attr );
    shape.translate( (steelShapeIconRect[0] - 30)/2, 8 );
    shape.node.onclick = callback;//function(){ GetWTShapes(); }
    var l = myCanvas.text(iconCenter[0], iconRect[1] - 8, label );
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;//function(){ GetWTShapes(); }
    var st = myCanvas.set();
    st.push(rect, shape, l );
    return st;
}

function drawHSSShapeIcon( label, callback, myCanvas )
{
    //background rect
    if( !label ) label = "HSS Shape";
    var rect = myCanvas.rect(0, 0, steelShapeIconRect[0], steelShapeIconRect[1] );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWTShapes(); }
    //shape
    var wShape = drawHSSShape( 20, 28, 4, myCanvas );
    wShape.attr( steel_shape_attr );
    setSelectableTrigger( wShape, rect, icon_rect_attr, selected_attr );
    wShape.translate( (steelShapeIconRect[0] - 30)/2, 8 );
    wShape.node.onclick = callback;//function(){ GetWTShapes(); }
    var l = myCanvas.text(iconCenter[0], iconRect[1] - 8, label );
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;//function(){ GetWTShapes(); }
    var st = myCanvas.set();
    st.push(rect, wShape, l );
    return st;
}

function drawParametricIcon( label, callback, myCanvas )
{
    //background rect
    if( !label ) label = "Parametric\nShapes";
    var rect = myCanvas.rect(0, 0, steelShapeIconRect[0], steelShapeIconRect[1] );
    rect.attr( icon_rect_attr );
    setSelectable(rect, icon_rect_attr, selected_attr);
    rect.node.onclick = callback;//function(){ GetWTShapes(); }
    var l = myCanvas.text(iconCenter[0], iconCenter[1], label );
    l.attr("font-size","14");
    l.attr("fill", "#003E70");
    setSelectableTrigger(l, rect, icon_rect_attr, selected_attr );
    l.node.onclick = callback;//function(){ GetWTShapes(); }
    var st = myCanvas.set();
    st.push(rect, l );
    return st;
}

